import { Dialog, DialogContent, DialogTrigger, MenuItem } from '@ff-it/ui';
import { ReactElement } from 'react';
import { Brief } from './Brief';

export function BriefButton(): ReactElement {
  return (
    <Dialog>
      <DialogTrigger>
        <MenuItem label="Brief" testId="toggle-brief" />
      </DialogTrigger>
      <DialogContent testId="brief-dialog">
        <Brief />
      </DialogContent>
    </Dialog>
  );
}
